/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Loader, Dimmer, Segment, Label, Icon, Popup, List, Pagination, Input, Modal
} from 'semantic-ui-react';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Update from 'immutability-helper';
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import api from '../../api';
import WithRouter from '../Extensions/WithRouter';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import Footer from '../Footer/Footer';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import PolicyRow from './PolicyRow';

class PolicyList extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.viewRef = React.createRef();
    this.policyBody = React.createRef();
    this.state = {
      pageSize: this.props.state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: this.props.state.user.view_mode,
      error: false,
      isLoading: false,
      hasMore: false,
      policyList: [],
      moreInfoIndex: [],
      popupType: '',
      activeIndex: [],
      popupIndex: '',
      sortValue: '9',
      isSort: false,
      searchKeyword: '',
      startDate: '',
      endDate: '',
      radioValue: 'dttime_any',
      filter: [],
      popupStatus: {
        conditionPopup: false,
      },
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      totalCount: 0,
    };
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.clearRadioValue = this.clearRadioValue.bind(this);
    this.clearAllValue = this.clearAllValue.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleMoreInfoOpen = this.handleMoreInfoOpen.bind(this);
    this.handleMoreInfoClose = this.handleMoreInfoClose.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleInputActivePageChange = this.handleInputActivePageChange.bind(this);
    this.handleActivePageChange = this.handleActivePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.createElementWithCanvas = this.createElementWithCanvas.bind(this);
    this.generatePdfCallback = this.generatePdfCallback.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.state.user.initPrecisionLevel();
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });
    if (this.policyBody) {
      this.getPolicyList();
    }
    document.addEventListener('mousedown', this.handleClickOutside);
    $(document).mousedown((e) => {
      const container = $('.wide_card_box .hover_area');
      if (container.has(e.target).length === 0) {
        container.removeClass('open');
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate() {
    const { state } = this.props;
    const { viewMode, pageSize } = this.state;

    const userStore = { ...state.user };

    if (viewMode === '' && userStore.view_mode !== '') {
      this.setState({
        viewMode: userStore.view_mode,
      });
    }

    if (pageSize === '' && userStore.page_limit !== '') {
      this.setState({
        pageSize: userStore.page_limit,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleActivePageChange(e) {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        policyList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getPolicyList(activePage, pageSize);
      });
    }
  }

  handleSearchChange(value) {
    this.setState({
      searchKeyword: value,
    });
  }

  handleInputActivePageChange(e, { value }) {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  }

  handlePageSizeChange(value) {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        policyList: [],
        activeIndex: [],
      },
      () => {
        this.getPolicyList();
      }
    );
  }

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      policyList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getPolicyList(activePage, pageSize);
    });
  };

  handleMoreInfoOpen = (index) => {
    const { moreInfoIndex } = this.state;
    let newState;

    if (moreInfoIndex.indexOf(index) === -1) {
      newState = [...moreInfoIndex, index];
    } else {
      newState = moreInfoIndex;
    }

    this.setState({
      moreInfoIndex: newState,
      popupType: 'type_2',
    });
  };

  handleMoreInfoClose = (index) => {
    const { moreInfoIndex } = this.state;
    const newState = moreInfoIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      moreInfoIndex: newState,
      popupType: '',
    });
  };

  handleClickOutside(event) {
    const container = $('.card_detail_popup');
    if (container && container.has(event.target).length === 0) {
      if (this.state.moreInfoIndex.length !== 0 && this.state.popupType !== '') {
        this.setState({
          moreInfoIndex: [],
          popupType: '',
        });
        return true;
      }
      return false;
    }
  }

  handleOnScroll() {
    const {
      getPolicyList,
      state: {
        error, isLoading, hasMore, viewMode
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getPolicyList(this.state.currentPage + 1);
    }
  }

  handleChange(value) {
    this.setState(
      {
        searchKeyword: value,
        policyList: [],
        activeIndex: [],
      },
      () => {
        this.getPolicyList();
      }
    );
  }

  handleFilterData(value) {
    this.setState(
      {
        policyList: [],
        activeIndex: [],
        startDate: value.uploaded_start,
        endDate: value.uploaded_end,
        filter: value.filter,
        radioValue: value.radio,
      },
      () => {
        this.getPolicyList();
      }
    );
  }

  handlePopupOpen(id) {
    const status = {
      conditionPopup: true,
    };
    this.setState({
      popupStatus: status,
      popupIndex: id,
    });
  }

  handlePopupClose() {
    const status = {
      conditionPopup: false,
    };
    this.setState({
      popupStatus: status,
      popupIndex: '',
    });
  }

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          policyList: [],
          activeIndex: [],
        },
        () => {
          this.getPolicyList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          policyList: [],
          activeIndex: [],
        },
        () => {
          this.getPolicyList();
        }
      );
    }
  };

  getPolicyList = (pageNo, limit) => {
    let text;
    let filterData;
    const {
      isSort, sortValue, radioValue, policyList, pageSize, filter
    } = this.state;
    const { state } = this.props;
    const userStore = { ...state.user };

    const page = pageNo || 1;
    let perPage = limit || pageSize;
    if (perPage === '') {
      perPage = userStore.page_limit || localStorage.getItem('page_limit');
    }

    if (filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
      filterData = `${filterData},${radioValue}`;
    } else {
      filterData = `${radioValue}`;
    }
    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'name';
      } else {
        text = 'name_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'revision_r';
      } else {
        text = 'revision';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'coverage_r';
      } else {
        text = 'coverage';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'category_r';
      } else {
        text = 'category';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'condition_r';
      } else {
        text = 'condition';
      }
      break;
    case sortValue === '6':
      if (isSort) {
        text = 'project_r';
      } else {
        text = 'project';
      }
      break;
    case sortValue === '7':
      if (isSort) {
        text = 'project_version_r';
      } else {
        text = 'project_version';
      }
      break;
    case sortValue === '8':
      if (isSort) {
        text = 'uploaded_file_r';
      } else {
        text = 'uploaded_file';
      }
      break;
    case sortValue === '9':
      if (isSort) {
        text = 'detected_r';
      } else {
        text = 'detected';
      }
      break;
    default:
      text = 'detected';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getPolicyList(
            {
              search: this.state.searchKeyword,
              filter: filterData,
              detected_start: this.state.startDate,
              detected_end: this.state.endDate,
              page,
              limit: perPage,
              order: text,
            }
          )
          .then((response) => {
            if (this.state.policyList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextPolicyList = response.response.map((item) => {
              return {
                policySettingId: item.policy_setting_id,
                policyName: item.policy_name,
                revision: item.revision,
                coverage: item.coverage,
                category: item.category,
                condition: item.condition,
                conditionDetail: item.condition_detail,
                projectCount: item.project_count,
                projectVersionCount: item.project_version_count,
                uploadedFileCount: item.uploaded_file_count,
                lastDetected: item.last_detected,
                hasRevision: item.has_revision,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              isLoading: false,
              policyList: [...policyList, ...nextPolicyList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoading: false,
            });
          });
      }
    );
  };

  getRevisionListWithPolicy = (id, name) => {
    const { navigate } = this.props;
    this.props.state.company.setRevisionfileName(name);
    navigate(`/results/policy/binary/${id}`);
  };

  getPolicyDetail = (policyId, revision) => {
    api
      .getPolicyDetail(
        {
          policy_setting_id: policyId,
          revision,
        }
      )
      .then((response) => {
        const { policyList } = this.state;
        const data = response.response;
        const updatedIndex = policyList.findIndex((item) => {
          return item.policySettingId === policyId && item.revision === revision;
        });

        const updatedData = Update(policyList[updatedIndex], {
          policyDetails: { $set: data },
        });

        const newData = Update(policyList, {
          $splice: [[updatedIndex, 1, updatedData]],
        });

        this.setState({
          policyList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 16) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 15 && tableEl.length > 16) || (i > 15 && (i - 15) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      policyList: [],
      activeIndex: [],
    }, () => {
      this.getPolicyList();
    });
  };

  toggleRow = (index, policyId, revision) => {
    const { activeIndex } = this.state;

    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getPolicyDetail(policyId, revision);
      newState = [...activeIndex, index];
    }
    this.setState({ activeIndex: newState });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        policyList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getPolicyList();
      }
    );
  };

  clearRadioValue = () => {
    this.setState(
      {
        policyList: [],
        activeIndex: [],
        startDate: '',
        endDate: '',
        radioValue: 'dttime_any',
      },
      () => {
        this.getPolicyList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        policyList: [],
        activeIndex: [],
        filter: [],
        startDate: '',
        endDate: '',
        radioValue: 'dttime_any',
      },
      () => {
        this.getPolicyList();
      }
    );
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        policyList: [],
        activeIndex: [],
      },
      () => {
        this.getPolicyList();
      }
    );
  }
  /*
  renderSortValue() {
    const { sortValue } = this.state;
    if (sortValue) {
      if (sortValue.indexOf('_') !== -1) {
        return <img src={downIcon} alt="" />;
      }
      return <img src={upIcon} alt="" />;
    }
    return null;
  }
*/

  renderValue() {
    const { filter, radioValue } = this.state;
    const { t } = this.props;

    const policyFilter = filter.filter((item) => {
      return item.indexOf('policy') > -1;
    });

    const uploadedDateFilter = radioValue;

    const filterObj = {
      policy: policyFilter,
      datetime: uploadedDateFilter,
    };

    return (
      <div>
        {filterObj.policy.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('settings.list.category')}</strong>
            </span>
            {filterObj.policy.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_cp') > -1 && t('list.title.component')}
                  {item.indexOf('_sc') > -1 && t('list.title.security')}
                  {item.indexOf('_lc') > -1 && t('list.title.license')}
                  {item.indexOf('_lt') > -1 && t('list.title.litigtor')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.datetime.indexOf('dttime_any') === -1 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.date')}</strong>
            </span>
            <Label as="a">
              {filterObj.datetime.indexOf('dttime_p24') > -1 && t('contents_header.menu.past_24_hours')}
              {filterObj.datetime.indexOf('dttime_pw') > -1 && t('contents_header.menu.past_week')}
              {filterObj.datetime.indexOf('dttime_pm') > -1 && t('contents_header.menu.past_month')}
              {filterObj.datetime.indexOf('dttime_cr') > -1
                  && `${this.state.startDate}~${this.state.endDate}`}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearRadioValue();
                }}
              />
            </Label>
          </Label.Group>
        )}

        {filter.length !== 0 || radioValue.indexOf('dttime_any') === -1 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  }

  renderConditionValue(data) {
    const objKey = data.conditionDetail;
    const { t } = this.props;
    const { popupIndex, popupStatus } = this.state;
    if (data.category === 'component') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && popupIndex === data.policySettingId
            }
            onOpen={() => {
              return this.handlePopupOpen(data.policySettingId);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.component.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('link_header.components')}
                      (
                      {objKey.component.length}
                      )
                    </List.Header>
                    {
                      objKey.component.map((item) => {
                        return (
                          <List.List key={uuidv4()}>
                            <span style={{ fontWeight: '500', marginRight: '5px' }}>{item.component}</span>
                            {`${item.version_condition || ''} ${item.selected_version || ''}`}
                          </List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'security') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && popupIndex === data.policySettingId
            }
            onOpen={() => {
              return this.handlePopupOpen(data.policySettingId);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.severity.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('settings.list.security_risk_severity')}
                      (
                      {objKey.severity.length}
                      )
                    </List.Header>
                    {
                      objKey.severity.map((item) => {
                        return (
                          <List.List key={uuidv4()}>
                            {
                              item === 'critical' && 'Critical'
                            }
                            {
                              item === 'high' && 'High'
                            }
                            {
                              item === 'medium' && 'Medium'
                            }
                            {
                              item === 'low' && 'Low'
                            }
                          </List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
              {
                objKey.code.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('settings.list.securities')}
                      (
                      {objKey.code.length}
                      )
                    </List.Header>
                    {
                      objKey.code.map((item) => {
                        return (
                          <List.List key={uuidv4()}>{item}</List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'license') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && popupIndex === data.policySettingId
            }
            onOpen={() => {
              return this.handlePopupOpen(data.policySettingId);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.family.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('list.title.license_family')}
                      (
                      {objKey.family.length}
                      )
                    </List.Header>
                    {
                      objKey.family.map((item) => {
                        return (
                          <List.List key={uuidv4()}>
                            {
                              item === 'protective' && 'Protective'
                            }
                            {
                              item === 'permissive' && 'Permissive'
                            }
                            {
                              item === 'others' && 'Others'
                            }
                          </List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
              {
                objKey.name.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('project.menu.licenses')}
                      (
                      {objKey.name.length}
                      )
                    </List.Header>
                    {
                      objKey.name.map((item) => {
                        return (
                          <List.List key={uuidv4()}>{item}</List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'litigator') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && popupIndex === data.policySettingId
            }
            onOpen={() => {
              return this.handlePopupOpen(data.policySettingId);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.name.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('project.menu.litigator')}
                      (
                      {objKey.name.length}
                      )
                    </List.Header>
                    {
                      objKey.name.map((item) => {
                        return (
                          <List.List key={uuidv4()}>
                            {
                              item === 'mchardy' && 'McHardy'
                            }
                            {
                              item === 'sfc' && 'SFC'
                            }
                            {
                              item === 'patents' && 'Patent Module'
                            }
                          </List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    }
    return (
      <span className="number">
        {data.condition}
      </span>
    );
  }

  renderMoreInformation = (array, type) => {
    if (type === 'security') {
      return array.map((item, index) => {
        return index % 5 === 0 && (
          <tr
            key={uuidv4()}
          >
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index].more === 'critical',
                        },
                        {
                          orange: array[index].more === 'high',
                        },
                        {
                          cheese: array[index].more === 'medium',
                        },
                        {
                          yellow: array[index].more === 'low',
                        }
                      )}
                    >
                      {array[index].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index + 1].more === 'critical',
                        },
                        {
                          orange: array[index + 1].more === 'high',
                        },
                        {
                          cheese: array[index + 1].more === 'medium',
                        },
                        {
                          yellow: array[index + 1].more === 'low',
                        }
                      )}
                    >
                      {array[index + 1].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 2],
                },
              )}
            >
              {
                array[index + 2] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index + 2].more === 'critical',
                        },
                        {
                          orange: array[index + 2].more === 'high',
                        },
                        {
                          cheese: array[index + 2].more === 'medium',
                        },
                        {
                          yellow: array[index + 2].more === 'low',
                        }
                      )}
                    >
                      {array[index + 2].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 3],
                },
              )}
            >
              {
                array[index + 3] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index + 3].more === 'critical',
                        },
                        {
                          orange: array[index + 3].more === 'high',
                        },
                        {
                          cheese: array[index + 3].more === 'medium',
                        },
                        {
                          yellow: array[index + 3].more === 'low',
                        }
                      )}
                    >
                      {array[index + 3].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 4],
                },
              )}
            >
              {
                array[index + 4] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index + 4].more === 'critical',
                        },
                        {
                          orange: array[index + 4].more === 'high',
                        },
                        {
                          cheese: array[index + 4].more === 'medium',
                        },
                        {
                          yellow: array[index + 4].more === 'low',
                        }
                      )}
                    >
                      {array[index + 4].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
          </tr>
        );
      });
    }
    if (type === 'component') {
      return array.map((item, index) => {
        return index % 2 === 0 && (
          <tr
            key={uuidv4()}
          >
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  array[index].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  array[index].more
                ) : null
              }
            </td>
            <td className="tac border-none">
              &nbsp;
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  array[index + 1].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  array[index + 1].more
                ) : null
              }
            </td>
          </tr>
        );
      });
    }

    if (type === 'license') {
      return array.map((item, index) => {
        return index % 5 === 0 && (
          <tr
            key={uuidv4()}
          >
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index + 1].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 2],
                },
              )}
            >
              {
                array[index + 2] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index + 2].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 3],
                },
              )}
            >
              {
                array[index + 3] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index + 3].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 4],
                },
              )}
            >
              {
                array[index + 4] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index + 4].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
          </tr>
        );
      });
    }

    if (type === 'litigator') {
      return array.map((item, index) => {
        return index % 5 === 0 && (
          <tr
            key={uuidv4()}
          >
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  array[index].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  array[index + 1].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 2],
                },
              )}
            >
              {
                array[index + 2] ? (
                  array[index + 2].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 3],
                },
              )}
            >
              {
                array[index + 3] ? (
                  array[index + 3].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 4],
                },
              )}
            >
              {
                array[index + 4] ? (
                  array[index + 4].name
                ) : null
              }
            </td>
          </tr>
        );
      });
    }
    return null;
  };

  render() {
    const {
      error,
      hasMore,
      isLoading,
      policyList,
      activeIndex,
      filter,
      sortValue,
      isSort,
      radioValue,
      moreInfoIndex,
      popupType,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      startDate,
      endDate,
      searchKeyword,
      totalCount
    } = this.state;

    const {
      state, location, params, t, navigate
    } = this.props;

    const style = {
      fontSize: '12px',
      fontWeight: '500',
    };

    return (
      <div ref={this.policyBody}>
        {/** ContentsHeader Area */}
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          radioValue={radioValue}
          totalCount={totalCount}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          isRenderListOnly={this.state.isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          state={state}
          location={location}
          params={params}
          translate={t}
          startDate={startDate}
          endDate={endDate}
          navigate={navigate}
          searchKeyword={searchKeyword}
          handleSearchChange={this.handleSearchChange}
        />
        <div className="content">
          {/** filter Value Area */}
          {filter.length !== 0 || radioValue.indexOf('dttime_any') === -1 ? (
            <div className="tag_list">{this.renderValue()}</div>
          ) : null}
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              {/** table Header start */}
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '13%', maxWidth: '120px' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '9.1%', maxWidth: '84px' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '21.7%' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap tal">
                          <div className="checkbox" />
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('settings.list.policy_name')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="2" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('settings.list.revision')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="3" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('settings.list.coverage')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="4" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('settings.list.category')}
                            {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="5" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('settings.list.detected_condition')}
                            {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="sum_th">
                          <table>
                            <colgroup>
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="6"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('contents_header.place_holder.project')}
                                    {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="7"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('contents_header.place_holder.project_version')}
                                    {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="8"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('contents_header.place_holder.uploaded_file')}
                                    {isSort && sortValue === '8' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '8' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="9" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.last_detected')}
                            {isSort && sortValue === '9' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '9' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/** Table Header End */}
              {
                policyList.map((item, index) => {
                  return (
                    <div
                      className={cx(
                        'wide_card_box',
                        {
                          expand: activeIndex.indexOf(index) >= 0,
                        },
                        {
                          card_detail_popup_show: moreInfoIndex.indexOf(index) >= 0,
                        },
                        {
                          type_2: popupType === 'type_2',
                        },
                      )}
                      key={uuidv4()}
                    >
                      <table className="wide_card_table wide_card_item">
                        <colgroup>
                          <col style={{ width: '3.9%', maxWidth: '36px' }} />
                          <col style={{ width: '13%', maxWidth: '120px' }} />
                          <col style={{ width: '9%' }} />
                          <col style={{ width: '9.1%', maxWidth: '84px' }} />
                          <col style={{ width: '13%' }} />
                          <col style={{ width: '13%' }} />
                          <col style={{ width: '21.7%' }} />
                          <col style={{ width: '13%' }} />
                          <col style={{ width: '4.3%', maxWidth: '40px' }} />
                        </colgroup>
                        <tbody>
                          <tr
                            className="sum_line"
                            onClick={() => {
                              return this.toggleRow(index, item.policySettingId, item.revision);
                            }}
                          >
                            <td className="checkbox_wrap border-none tal">
                              <div className="checkbox" />
                            </td>
                            {
                              !item.hasRevision ? (
                                <td
                                  className="border-none tal"
                                >
                                  <a
                                    className="link_button"
                                    onClick={() => { return this.getRevisionListWithPolicy(item.policySettingId, item.policyName); }}
                                    onKeyUp={() => { return this.getRevisionListWithPolicy(item.policySettingId, item.policyName); }}
                                  >
                                    {
                                      item.policyDetails && item.policyDetails.current_name !== item.policyName ? (
                                        <Popup
                                          content={`${item.policyName} was changed to ${item.policyDetails.current_name}`}
                                          trigger={<span>{item.policyName}</span>}
                                          position="top left"
                                          style={style}
                                          size="small"
                                          inverted
                                        />
                                      ) : (
                                        item.policyName
                                      )
                                    }
                                  </a>
                                </td>
                              ) : (
                                <td className="border-none tal">
                                  {
                                    item.policyDetails && item.policyDetails.current_name !== item.policyName ? (
                                      <Popup
                                        content={`${item.policyName} was changed to ${item.policyDetails.current_name}`}
                                        trigger={<span>{item.policyName}</span>}
                                        position="top left"
                                        style={style}
                                        size="small"
                                        inverted
                                      />
                                    ) : (
                                      item.policyName
                                    )
                                  }
                                </td>
                              )
                            }
                            <td className="tal">
                              rev_
                              {item.revision}
                            </td>
                            <td className="tac">
                              {item.coverage === 'company' && 'Company'}
                              {item.coverage === 'project' && 'Project'}
                            </td>

                            <td className="tac">
                              {item.category === 'component' && 'Component'}
                              {item.category === 'security' && 'Security'}
                              {item.category === 'license' && 'License'}
                              {item.category === 'litigator' && 'Litigator'}
                            </td>
                            <td className="tal">{this.renderConditionValue(item)}</td>
                            <td className="sum_td tac">
                              <table className="sub_table">
                                <colgroup>
                                  <col style={{ width: '33%' }} />
                                  <col style={{ width: '33%' }} />
                                  <col style={{ width: '33%' }} />
                                </colgroup>
                                <tbody>
                                  <tr>
                                    <td className="tac">{item.projectCount}</td>
                                    <td className="tac">{item.projectVersionCount}</td>
                                    <td className="tac">{item.uploadedFileCount}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td className="tac">{item.lastDetected}</td>
                            <td className="border-none tal">
                              <a
                                className="expand_button"
                              >
                                <img src={expandBtn} alt="" />
                              </a>
                            </td>
                          </tr>
                          <tr className="extend_item">
                            <td className="checkbox_wrap border-none tal">&nbsp;</td>
                            <td className="border-none tal">&nbsp;</td>
                            <td className="border-none tal">&nbsp;</td>
                            <td className="border-none tac">&nbsp;</td>

                            <td className="border-none tac">&nbsp;</td>
                            <td className="border-none sum_td" colSpan="3">
                              {
                                item.policyDetails
                              && (
                                <PolicyRow
                                  childRef={this.viewRef}
                                  rowData={item.policyDetails}
                                  t={t}
                                  state={state}
                                  policyId={item.policySettingId}
                                  location={location}
                                  params={params}
                                />
                              )
                              }
                            </td>
                            <td className="border-none tal">
                              &nbsp;
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {
                        item.policyDetails ? (
                          <div className="wide_card_detail">
                            <div className="wide_card_detail_top type_description">
                              <p className="description">{t('list.title.all_condition')}</p>
                              <p className="version_text">{item.policyDetails.all_condition}</p>
                              <p className="description">{t('list.title.detected_condition')}</p>
                              <p className="version_text">{item.policyDetails.detected_condition}</p>
                              <p className="foo">{t('list.title.description')}</p>
                              <p className="version_text">
                                {item.policyDetails.description}
                              </p>
                            </div>
                            <div className="wide_card_detail_bottom">
                              <a
                                className={cx('card_detail_popup_show', {
                                  active: moreInfoIndex.indexOf(index) >= 0 && popupType === 'type_2',
                                })}
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  return this.handleMoreInfoOpen(index);
                                }}
                                onKeyUp={() => {
                                  return this.handleMoreInfoOpen(index);
                                }}
                              >
                                {t('list.title.more_information')}
                              </a>
                            </div>
                          </div>
                        ) : null
                      }
                      {
                        popupType === 'type_2'
                      && (
                        <div className="card_detail_popup card_detail_popup_3">
                          <div className="popup_box">
                            <h3 className="popup_header">
                              {t('list.title.more_information')}
                              <a
                                className="card_detail_popup_hide"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  return this.handleMoreInfoClose(index);
                                }}
                                onKeyUp={() => {
                                  return this.handleMoreInfoClose(index);
                                }}
                              >
                                <img src={closeBtn} alt="" />
                              </a>
                            </h3>
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <table className="wide_card_table information wide_card_item">
                                <colgroup>
                                  <col style={{ width: '20%' }} />
                                  <col style={{ width: '20%' }} />
                                  <col style={{ width: '20%' }} />
                                  <col style={{ width: '20%' }} />
                                  <col style={{ width: '20%' }} />
                                </colgroup>
                                <tbody>
                                  {
                                    item.policyDetails && item.policyDetails.category === 'component' ? (
                                      this.renderMoreInformation(item.policyDetails.more_information, 'component')
                                    ) : null
                                  }
                                  {
                                    item.policyDetails && item.policyDetails.category === 'security' ? (
                                      this.renderMoreInformation(item.policyDetails.more_information, 'security')
                                    ) : null
                                  }
                                  {
                                    item.policyDetails && item.policyDetails.category === 'license' ? (
                                      this.renderMoreInformation(item.policyDetails.more_information, 'license')
                                    ) : null
                                  }
                                  {
                                    item.policyDetails && item.policyDetails.category === 'litigator' ? (
                                      this.renderMoreInformation(item.policyDetails.more_information, 'litigator')
                                    ) : null
                                  }
                                </tbody>
                              </table>
                            </Scrollbars>
                          </div>
                        </div>
                      )
                      }
                    </div>
                  );
                })
              }
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>{t('modal.message.loading')}</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && policyList.length !== 0
                && (
                  <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(PolicyList))));
